module.exports = __webpack_public_path__ + "img/Flag_of_the_Philippines.95093d7f.svg";